<mt-card class="mt-card"
		 :title="$tc('postfinancecheckout-settings.settingForm.advancedOptions.cardTitle')">
	<sw-container>
		<div v-if="actualConfigData" class="postfinancecheckout-settings-advanced-options-fields">
			<sw-inherit-wrapper
					v-model:value="actualConfigData[CONFIG_STOREFRONT_WEBHOOKS_UPDATE_ENABLED]"
					:inheritedValue="selectedSalesChannelId == null ? null : allConfigs['null'][CONFIG_STOREFRONT_WEBHOOKS_UPDATE_ENABLED]"
					:customInheritationCheckFunction="checkBoolFieldInheritance">
				<template #content="props">
					<sw-switch-field
							:name="CONFIG_STOREFRONT_WEBHOOKS_UPDATE_ENABLED"
							bordered
							:mapInheritance="props"
							:label="$tc('postfinancecheckout-settings.settingForm.advancedOptions.webhooksUpdateEnabled.label')"
							:helpText="$tc('postfinancecheckout-settings.settingForm.advancedOptions.webhooksUpdateEnabled.tooltipText')"
							:disabled="props.isInherited"
							:value="props.currentValue"
							@update:value="props.updateCurrentValue">
					</sw-switch-field>
				</template>
			</sw-inherit-wrapper>

			<sw-inherit-wrapper
					v-model:value="actualConfigData[CONFIG_STOREFRONT_PAYMENTS_UPDATE_ENABLED]"
					:inheritedValue="selectedSalesChannelId == null ? null : allConfigs['null'][CONFIG_STOREFRONT_PAYMENTS_UPDATE_ENABLED]"
					:customInheritationCheckFunction="checkBoolFieldInheritance">
				<template #content="props">
					<sw-switch-field
							:name="CONFIG_STOREFRONT_PAYMENTS_UPDATE_ENABLED"
							bordered
							:mapInheritance="props"
							:label="$tc('postfinancecheckout-settings.settingForm.advancedOptions.paymentsUpdateEnabled.label')"
							:helpText="$tc('postfinancecheckout-settings.settingForm.advancedOptions.paymentsUpdateEnabled.tooltipText')"
							:disabled="props.isInherited"
							:value="props.currentValue"
							@update:value="props.updateCurrentValue">
					</sw-switch-field>
				</template>
			</sw-inherit-wrapper>
		</div>
	</sw-container>
</mt-card>

